import { BASE_PATH_SERVER } from './config';

// GET /garantias — catálogo de garantías del tenant del token (solo activas),
// shape [{ id, nombre, cuerpo, orden }]. Alimenta el selector de garantía en
// el composer de presupuesto V3.
export const getGarantiasApi = async (token) => {
  const dst = `${BASE_PATH_SERVER}garantias`;
  const params = {
    method: 'GET',
    headers: {
      Authorization: token,
    },
  };
  return fetch(dst, params)
    .then((response) => response.json())
    .then((result) => result)
    .catch((err) => ({
      status: 'client',
      codeMessage: 'ERROR_EN_LA_PETICION',
      message: err.message,
    }));
};
